// extracted by mini-css-extract-plugin
export var divider = "_n2-0";
export var systemMessage = "_n2-1";
export var systemMessageWrapper = "_n2-2";